import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 28px 28px;
`;

export const StyledImage = styled.img`
  align-self: center;
  margin-top: 60px;
  width: 320px;
  max-width: 90vw;
`;
